import { RouterProvider } from "react-router-dom"
import { ComponentProvier } from './ComponentProvier'
import './App.css';
import './Call.css';
import './Stylesheets/report.css'
import './Components/newchat.css'
import './Components/Maintenance/maintenance.css'
import './Stylesheets/Admin.css'
import './Stylesheets/TaskReport.css'
import './Stylesheets/tasks/Calendar.css'
import './Stylesheets/tasks/quickTask.css'
import './Stylesheets/tasks/taskmain.css'
import './Stylesheets/tasks/taskmanagement.css'
import './Stylesheets/tasks/TaskPartial.css'
import './Stylesheets/tasks/tasks.css'
import './Stylesheets/tasks/taskSettings.css'
import './Stylesheets/Calendar.css'
import "react-datepicker/dist/react-datepicker.css";
import 'react-tooltip/dist/react-tooltip.css';
import './Stylesheets/venue.css';
import './Stylesheets/billingsubscription.css';
import './Stylesheets/TagFile.css';
import './Stylesheets/leftSection.css';
import "./Stylesheets/ThemeCustomizer.css";
import './Stylesheets/custom.css';
import './Stylesheets/Responsiveness.css'

import './utils/frontendAnalytics';
import './utils/apiInterceptor';
import { Suspense, useEffect } from 'react';
// import { CircularProgress } from "@mui/material";
import { ThemeProvider } from "./context/ThemeContext";

// const RouteFallback = () => (
//   <div
//     style={{
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       height: '100vh',
//       width: '100%',
//     }}
//   >
//     <CircularProgress />
//   </div>
// );


function App() {

  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua);
    if (isMobile) {
      window.location.href = 'http://camobilecdn02.freeli.io';
    }
  }, []);
  return (
    <>
      <Suspense fallback={null}>
        <ThemeProvider>
          <RouterProvider router={ComponentProvier} />
        </ThemeProvider>
      </Suspense>

    </>

  );
}

export default App;
